import Select from "react-select";
import { orderTypeOptions, contractStatusOptions } from "@/constants/selectOptions";

export const ContractInfo = ({ formData, handleChange, setFormData, disabled }) => {
    const { contractType, serialNumber, contractStatus } = formData;

    return (
        <>
            {/* 계약유형 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        계약유형 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={orderTypeOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="계약유형 선택"
                            value={orderTypeOptions.find((opt) => opt.value === contractType)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    contractType: option.value,
                                }))
                            }
                            isDisabled={formData.orderId || disabled}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>계약번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder=""
                            name="serialNumber"
                            value={serialNumber || ""}
                            onChange={handleChange}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>계약상태</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={contractStatusOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="계약상태"
                            value={contractStatusOptions.find((opt) => opt.value === contractStatus)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    contractStatus: option.value,
                                }))
                            }
                            isDisabled
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
